import Main from './components/Main.jsx'

import 'bootstrap/dist/css/bootstrap.css'

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
